import { Grid, IconButton, Button, TextField, Box } from '@mui/material'
import { RotateLeft } from '@mui/icons-material'
import React from 'react'

interface PrioritySearchProps {
  searchValue: string
  onChangeSearchValue: React.Dispatch<React.SetStateAction<string>>
  handleSearch: () => void
}

export const PrioritySearch: React.FC<PrioritySearchProps> = ({
  onChangeSearchValue,
  searchValue,
  handleSearch
}) => {
  return (
    <Grid container>
      <Grid item xs={8} sm={4} md={3}>
        <TextField
          variant='outlined'
          name='searchpriority'
          value={searchValue}
          onChange={(e) => onChangeSearchValue(e.target.value)}
          fullWidth
          label='Ingresar prioridad...'
        />
      </Grid>
      <Grid item xs={1} sm={4} md={6}></Grid>
      <Grid item xs={3} sm={4} md={3}>
        <Box display='flex' justifyContent='flex-end' alignItems='center'>
          <IconButton onClick={() => onChangeSearchValue('')}>
            <RotateLeft />
          </IconButton>
          <Button
            variant='contained'
            color='primary'
            onClick={handleSearch}
            fullWidth
          >
            Buscar
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}
